module.exports = __webpack_public_path__ + "img/users.0b4983a7.svg";